import { render, staticRenderFns } from "./ManageStaffList.vue?vue&type=template&id=67b5f938&"
import script from "./ManageStaffList.vue?vue&type=script&lang=js&"
export * from "./ManageStaffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports